import React from "react";
import {
  FaBookOpen,
  FaClock,
  FaCrown,
  FaEnvelope,
  FaGraduationCap,
  FaPhoneAlt,
  FaShieldAlt,
  FaWhatsapp,
} from "react-icons/fa";

import "./ContactStyles.css";

const SUPPORT_EMAIL = "kugathaj@gmail.com";
const SUPPORT_PHONE_DISPLAY = "+49 172 5467119";
const SUPPORT_PHONE_TEL = "+491725467119";

const Contact: React.FC = () => {
  const whatsappMessage = encodeURIComponent(
    "Hallo, ich brauche Hilfe mit DEUTSCH A1-C2.",
  );

  return (
    <main className="contact-page">
      <section className="contact-container">
        <header className="contact-header-card">
          <p className="contact-kicker">
            <FaShieldAlt />
            <span>Kontakt</span>
          </p>

          <h1 className="contact-page-title">Kontakt aufnehmen</h1>

          <p className="contact-subtitle">
            Wenn Sie ein Problem mit Login, Premium-Zugang, Büchern, Kursen
            oder Zahlungen haben, kontaktieren Sie uns bitte. Wir helfen Ihnen
            so schnell wie möglich.
          </p>
        </header>

        <div className="contact-learning-grid">
          <article className="contact-group contact-direct-group">
            <div className="contact-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="contact-card-left">
              <div className="contact-level-block">
                <span className="contact-level-icon">
                  <FaEnvelope />
                </span>

                <span className="contact-status">Kontakt</span>
              </div>

              <div className="contact-title-block">
                <h2>Direkt</h2>
                <p>Support</p>
                <small>3 Wege</small>
              </div>
            </section>

            <section className="contact-card-right">
              <ul className="contact-list">
                <li className="contact-item">
                  <a
                    className="contact-button"
                    href={`mailto:${SUPPORT_EMAIL}?subject=DEUTSCH A1-C2 Support Anfrage`}
                  >
                    <span className="contact-button-icon">
                      <FaEnvelope />
                    </span>

                    <span className="contact-name">
                      <strong>E-Mail</strong>
                      <small>{SUPPORT_EMAIL}</small>
                    </span>
                  </a>
                </li>

                <li className="contact-item">
                  <a className="contact-button" href={`tel:${SUPPORT_PHONE_TEL}`}>
                    <span className="contact-button-icon">
                      <FaPhoneAlt />
                    </span>

                    <span className="contact-name">
                      <strong>Telefon</strong>
                      <small>{SUPPORT_PHONE_DISPLAY}</small>
                    </span>
                  </a>
                </li>

                <li className="contact-item">
                  <a
                    className="contact-button"
                    href={`https://wa.me/${SUPPORT_PHONE_TEL.replace(
                      "+",
                      "",
                    )}?text=${whatsappMessage}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="contact-button-icon contact-whatsapp-icon">
                      <FaWhatsapp />
                    </span>

                    <span className="contact-name">
                      <strong>WhatsApp</strong>
                      <small>{SUPPORT_PHONE_DISPLAY}</small>
                    </span>
                  </a>
                </li>
              </ul>

              <div className="contact-note">
                <strong>Hinweis:</strong> Bitte schreiben Sie Ihre
                E-Mail-Adresse, Ihr Problem und den Bereich, bei dem Sie Hilfe
                brauchen. So können wir Ihren Zugang schneller prüfen.
              </div>
            </section>
          </article>

          <article className="contact-group contact-help-group">
            <div className="contact-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="contact-card-left">
              <div className="contact-level-block">
                <span className="contact-level-icon">
                  <FaShieldAlt />
                </span>

                <span className="contact-status">Hilfe</span>
              </div>

              <div className="contact-title-block">
                <h2>Support</h2>
                <p>Bereiche</p>
                <small>4 Themen</small>
              </div>
            </section>

            <section className="contact-card-right">
              <ul className="contact-help-list">
                <li className="contact-help-item">
                  <div className="contact-help-button">
                    <span className="contact-button-icon">
                      <FaCrown />
                    </span>

                    <span className="contact-name">
                      <strong>Premium-Zugang</strong>
                      <small>
                        Hilfe bei Premium, Kündigung, Abo-Status und Zugang.
                      </small>
                    </span>
                  </div>
                </li>

                <li className="contact-help-item">
                  <div className="contact-help-button">
                    <span className="contact-button-icon">
                      <FaBookOpen />
                    </span>

                    <span className="contact-name">
                      <strong>Bücherzugang</strong>
                      <small>
                        Hilfe, wenn Bücher oder Niveaus nicht richtig öffnen.
                      </small>
                    </span>
                  </div>
                </li>

                <li className="contact-help-item">
                  <div className="contact-help-button">
                    <span className="contact-button-icon">
                      <FaGraduationCap />
                    </span>

                    <span className="contact-name">
                      <strong>Kurse</strong>
                      <small>
                        Fragen zu A1, A2, B1, B2 und Kursfreischaltung.
                      </small>
                    </span>
                  </div>
                </li>

                <li className="contact-help-item">
                  <div className="contact-help-button">
                    <span className="contact-button-icon">
                      <FaClock />
                    </span>

                    <span className="contact-name">
                      <strong>Antwortzeit</strong>
                      <small>Wir antworten so schnell wie möglich.</small>
                    </span>
                  </div>
                </li>
              </ul>
            </section>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Contact; 